import { useRouter } from 'found';
import React, { useState } from 'react';
import { getCurrentAccount } from '../../../../account_helpers';
import { makeMutation } from '../../../../api/helpers';
import { AddService } from '../../../../api/mutations';
import ContentCenterer from '../../../../components/ContentCenterer';
import DescribeAPI from './DescribeAPI';
import styled from 'styled-components';
import Spacer from '../../../../components/Spacer';
import { useToastDispatch } from '../../../../components/Toast/ToastProvider';

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

export type FormData = {
  apiType: undefined | 'paid' | 'free';
  apiName: string;
  apiDescription: string;
};

export type FormDataUpdates = {
  apiType?: 'paid' | 'free';
  apiName?: string;
  apiDescription?: string;
};

function CreateAPI() {
  const page = 1;
  const [formData, setFormData] = useState<FormData>({
    apiType: undefined,
    apiName: '',
    apiDescription: '',
  });

  const { router } = useRouter();
  const dispatch = useToastDispatch();

  // onClose go back to previous page
  const onClose = () => {
    router.go(-1);
  };

  const updateFormData = (updates: FormDataUpdates) => {
    setFormData({ ...formData, ...updates });
  };

  const onCreateAPI = async () => {
    const variables = {
      name: formData.apiName,
      description: formData.apiDescription,
      accountID: getCurrentAccount(),
    };

    try {
      const resp: any = await makeMutation(AddService, variables);
      router.push(`/api_manager/api/${resp.addService.id}`);
    } catch (err) {
      dispatch({ text: err.toString(), alert: 'error', stayFor: 4000 });
    }
  };

  return (
    <Container>
      <ContentCenterer maxWidth={'838px'}>
        {/* {page === 0 && (
        <SelectAPI
          onClose={onClose}
          onNext={() => {
            setPage(page + 1);
          }}
        />
      )} */}
        <Spacer spacing={4} vertical />
        {page === 1 && (
          <DescribeAPI
            onClose={onClose}
            onNext={onCreateAPI}
            formData={formData}
            updateFormData={updateFormData}
          />
        )}
      </ContentCenterer>
    </Container>
  );
}

export default CreateAPI;
